import { respondTo } from '@/respondTo';
import Styled from 'styled-components';


export const MainSupportContainer = Styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 2.5rem 1.25rem;
    gap: 1.25rem;
    color: var(--on-primary-dark);
  
    &:after {
        content : "";
        position: absolute;
        left    : 1.25rem;
        right   : 1.25rem;
        bottom  : 0;
        height  : 1px;
        width   : calc(100% - 2.5rem);  
        background-color: var(--on-primary-dark);
    
    }

    ${respondTo.desktop`
        flex-direction: row;
        justify-content: space-between;
        padding: 2.5rem;
        &:after {
            left    : 2.5rem;
            right   : 2.5rem;
            width   : calc(100% - 5rem);  
        }
        `}

    ${respondTo.desktop_xl`
        padding: 4.375rem; 
        &:after {
            left    : 4.375rem;
            right   : 4.375rem;
            width   : calc(100% - 8.75rem);  
        }
        `}
 
    `;

    export const TitleContainer = Styled.div`
        h2 {
        color: var(--on-background-light);
    }
    ${respondTo.desktop`
    width: 50%;
    display: flex;
    align-items: flex-start;
    text-align: left;
    height: 100%;
    padding: 0 12rem 0 0;


    
    `}
    `;

export const InnerContainer = Styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 1.25rem;

    ${respondTo.desktop`
    width: 50%;
    gap: 2rem;
    align-items: flex-start;
    `}
    `;  

export const HeroContainer = Styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    gap: 0.625rem;
   `;

   export const Img = Styled.img`
    width: 5rem;
    height: auto;

    ${respondTo.desktop`
    width: 6.25rem;
    `}
    `;

export const ContactInfo = Styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 0.625rem;

    em {
        color: var(--on-background-light);
    }

    p {
        color: var(--on-background-light);
    }
    `;


export const BtnContainer = Styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 1.25rem;

    ${respondTo.tablet_landscape_s`
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    `}

    ${respondTo.desktop`
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 0.625rem;
    `}  
    `;

export const QuestionP = Styled.p`
    display: flex;
    align-self: flex-start;
    justify-content: flex-start;
    gap: 0.625rem;

    ${respondTo.tablet_landscape_s`
    align-self: center;
    justify-content: center;
    `}
`;
